import { useEffect } from 'react';
import { getSeoForPath } from '../../shared/seo';

function setMetaByName(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setMetaByProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonicalLink(href: string) {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLdScript(jsonLd: Record<string, unknown>) {
  let script = document.getElementById('seo-json-ld') as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement('script');
    script.id = 'seo-json-ld';
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(jsonLd);
}

/**
 * Synchronizes document head metadata, Open Graph, Twitter Cards, canonical URL,
 * and JSON-LD structured data on every client route transition.
 */
export function useSeo(currentPath: string) {
  useEffect(() => {
    const seo = getSeoForPath(currentPath);

    document.title = seo.title;
    setMetaByName('description', seo.description);
    setMetaByName('keywords', seo.keywords);
    setMetaByName('robots', seo.robots);
    setCanonicalLink(seo.canonicalUrl);

    // Open Graph
    setMetaByProperty('og:type', seo.ogType);
    setMetaByProperty('og:url', seo.canonicalUrl);
    setMetaByProperty('og:title', seo.title);
    setMetaByProperty('og:description', seo.description);
    setMetaByProperty('og:image', seo.ogImage);
    setMetaByProperty('og:image:alt', seo.ogImageAlt);

    // Twitter Cards
    setMetaByName('twitter:title', seo.title);
    setMetaByName('twitter:description', seo.description);
    setMetaByName('twitter:image', seo.ogImage);
    setMetaByName('twitter:image:alt', seo.ogImageAlt);

    // Structured Data (JSON-LD)
    setJsonLdScript(seo.jsonLd);
  }, [currentPath]);
}
